function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Utilitaire contenant des fonctions statiques pour les couleurs
 * @category Utils
 * @hideconstructor
 */
var ColorUtils = /*#__PURE__*/function () {
  function ColorUtils() {}

  // Constante pour le palier de luminosité

  /**
   * Fonction permettant de savoir si une couleur est claire ou sombre
   * @param {string} color La couleur au format hexadécimal de 6 caractères (ex : #e4ac52)
   * @returns {boolean} true si _color_ est sombre, false si _color_ est claire
   */
  ColorUtils.isColorDark = function isColorDark(color) {
    return ColorUtils.getBrightness(color) < ColorUtils.MIN_BRIGHTNESS;
  }
  /**
   * Fonction permettant de récupérer la luminosité d'une couleur
   * @param {string} color La couleur au format hexadécimal de 6 caractères (ex : #e4ac52)
   * @returns {number} La luminosité de la couleur _color_
   */
  ;

  ColorUtils.getBrightness = function getBrightness(color) {
    try {
      var rStr = color.substr(1, 2);
      var gStr = color.substr(3, 2);
      var bStr = color.substr(5, 2);
      var r = parseInt(rStr, 16);
      var g = parseInt(gStr, 16);
      var b = parseInt(bStr, 16);
      return parseInt((r / 1.2 + g * 1.2 + b / 1.4) / 3);
    } catch (error) {
      return ColorUtils.MIN_BRIGHTNESS;
    }
  };

  return ColorUtils;
}(); // Exports


_defineProperty(ColorUtils, "MIN_BRIGHTNESS", 100);

export var isColorDark = ColorUtils.isColorDark;
export var getBrightness = ColorUtils.getBrightness;